import React from "react";
import PropTypes from "prop-types";
import logo from "../../assets/images/icon.png";
import "../../css/footer.scss";

const Footer = ({ details }) => (
  <section id="footer-wrapper">
    <footer>
      <div id="meta">
        <img src={logo} id="tmd" alt="The Michigan Daily logo" />
        <div id="titles">
          <p id="title">{details.title}</p>
          <p id="subtitle">{details.subtitle}</p>
        </div>
      </div>
      <div id="social">
        <a target="_blank" rel="noreferrer" href={details.Instagram} className="social-media">
          <i className="fab fa-instagram" />
        </a>
        <a target="_blank" rel="noreferrer" href={details.Facebook} className="social-media">
          <i className="fab fa-facebook" />
        </a>
        <a target="_blank" rel="noreferrer" href={details.Twitter} className="social-media">
          <i className="fab fa-twitter" />
        </a>
      </div>
      <div id="dek">
        {details.mission}
      </div>
      <div id="credit">
        <div className="ack">
          {details.copyright}
        </div>
        <div className="ack">
          {details.graphic}
        </div>
        <div className="ack">
          {details.designers}
        </div>
        <div className="ack">
          {details.developers}
        </div>
      </div>
    </footer>
  </section>
)

Footer.propTypes = {
  details: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    Instagram: PropTypes.string.isRequired,
    Facebook: PropTypes.string.isRequired,
    Twitter: PropTypes.string.isRequired,
    mission: PropTypes.string.isRequired,
    copyright: PropTypes.string.isRequired,
    graphic: PropTypes.string.isRequired,
    designers: PropTypes.string.isRequired,
    developers: PropTypes.string.isRequired,
  })
}

Footer.defaultProps = {
  details: undefined
}

export default Footer;
